import { useTranslation } from 'react-i18next'
import { motion } from 'motion/react'
import heartSand from '../assets/heart-sand.webp'

export default function Quote() {
  const { t } = useTranslation()

  return (
    <section id="quote-section" className="bg-rot py-24 text-center px-6 overflow-hidden">
      <motion.img
        initial={{ opacity: 0, scale: 0.5 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.5, ease: 'easeOut' }}
        src={heartSand}
        alt="buenas heart"
        loading="lazy"
        width={1182}
        height={1182}
        className="w-8 mx-auto mb-8"
      />
      <motion.blockquote
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.7, delay: 0.1 }}
        className="font-headline italic text-sand text-3xl sm:text-4xl md:text-5xl max-w-xl mx-auto leading-snug mb-8"
      >
        {t('quote.text')
          .split('\n')
          .map((line, i, arr) => (
            <span key={i}>
              {line}
              {i < arr.length - 1 && <br />}
            </span>
          ))}
      </motion.blockquote>
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.5, delay: 0.3 }}
        className="font-body text-sand/70 text-base tracking-widest uppercase mb-10"
      >
        {t('quote.author')}
      </motion.p>
      <motion.a
        initial={{ opacity: 0, y: 15 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.5, delay: 0.4 }}
        href="#contact"
        className="border border-sand/40 text-sand rounded-full px-8 py-3 text-sm font-body hover:bg-sand hover:text-rot transition-all inline-block"
      >
        {t('quote.cta')}
      </motion.a>
    </section>
  )
}
